import React from "react";

import CellArrayItemWithTooltip from "../../../ui/Table/CellArrayItemWithTooltip";

import { Rating } from "react-simple-star-rating";

const columns = [
  {
    name: "Coach Name",
    selector: "attributes.full_name",
    sortable: true,
    width: "280px",
  },
  {
    name: "Email",
    selector: "attributes.email",
    sortable: true,
    width: "200px",
  },
  {
    name: "Rating",
    sortable: true,
    selector: "attributes.ratings",
    cell: (row) => (
      <>
        <Rating
          initialValue={row.attributes.ratings}
          readonly={true}
          allowFraction={true}
          size="20"
          SVGstrokeColor="#F9C35A"
          fillColor="#F9C35A"
        />
        {row.attributes.ratings_text}
      </>
    ),
    width: "170px",
  },
  {
    name: "Language",
    sortable: false,
    cell: (row) => <CellArrayItemWithTooltip arr={row.attributes.languages} />,
    width: "150px",
  },
  {
    name: "Career Level",
    sortable: false,
    cell: (row) => (
      <CellArrayItemWithTooltip arr={row.attributes.career_levels} />
    ),
    width: "150px",
  },
  {
    name: "On Pause",
    selector: "attributes.pause",
    sortable: true,
    width: "100px",
  },
];

export default columns;
